import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router'
import config from '../config';
import errorImage from '../assets/error-image.png';
import { GlobalContext } from '../global/GlobalProvider';
import ImageGallery from '../common/ImageGallery';

export default function Casino() {

    useEffect(() => {
        document.body.classList.add('hide-sidemenu');
        return () => {
            document.body.classList.remove('hide-sidemenu');
        }
    }, []);
    const navigate = useNavigate();
    const [liveCasinoApi, setLiveCasino] = useState();
    const [active, setActive] = useState();
    const [providerList, setProviderList] = useState([]);
    const [results, setResults] = useState();
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedOption, setSelectedOption] = useState("");
    const [selectedProvider, setSelectedProvider] = useState(config.defualtGame);
    const [selectedType, setSelectedType] = useState("All");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const token = sessionStorage.getItem("token");
    const { openPopup, loggedIn, isLoggedOut } = useContext(GlobalContext);
    const [isLoggedIn, setIsLoggedIn] = useState(!!sessionStorage.getItem('loggedIn'));
    const dropdownRef = useRef(null);
    const [dropdown, setDropdown] = useState();
    const [selectTab, setSelectTab] = useState(config.defualtGame);
    const [gameTab, setGameTab] = useState(config.defualtGame);
    const [tabType, setTabType] = useState("");
    const [gameName, setgameName] = useState("");
    const [notificationModal, setNotificationModal] = useState(false);
    const [activeClick, setActiveClick] = useState();
    const handlePlayNow = (item) => {
      if(item.provider_name === "DC" && item.sub_provider_name === "Evolution Gaming"){
        setActiveClick(item)
        setNotificationModal(true);
        return;
      }
      navigate(`/live_casinoInPlay/${item._id}`);
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

    const dropdownHandle = () => {
      setDropdown(!dropdown);
    }

    const handleError = (e) => {
      e.target.onerror = null; // Prevent infinite loop if fallback also fails
      e.target.src = errorImage;
    };


    useEffect(() => {
      callAPI(config.defualtGame, "All");
      callProviderAPI(config.defualtGame, "All");
    }, []);

    const callAPI = (name, type) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${process.env.REACT_APP_BASE_URL}/new_royalcasino?provider=${name}&type=${type}`, requestOptions)
        .then(async (response) => {
          let paresData = await response.json();
          setLiveCasino(paresData.games);
          setgameName(paresData.gameNameAll)
          console.log("live_casino - ", paresData);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const callProviderAPI = (name,type) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${process.env.REACT_APP_BASE_URL}/new_royalcasino?provider=${name}&type=${type}`, requestOptions)
        .then(async (response) => {
          setGameTab(config.defualtGame);
          let paresData = await response.json();
          let list = paresData.providerNames;
          setgameName(paresData.gameNameAll);
          let newString = "All"
          setProviderList([newString, ...list]);
          console.log("providerlist - ", paresData);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const handleSearchChange = async (event) => {
      const value = event.target.value;
      setSearchTerm(value);

      if (value.length > 1) {
        setShowSuggestions(true);

        try {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            whiteLabelName: config.WhiteLable,
            search: value,
          });
          console.log("gameSearch Req", raw);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(
            `${process.env.REACT_APP_BASE_URL}/api/v1/games/gameSearch`,
            requestOptions
          )
            .then(async (response) => {
              let paresData = await response.json();
              setResults(paresData);
              console.log("gameSearch Response : ", paresData);
            })
            .catch((error) => {
              console.log("gameSearch Error : ", error);
            });
        } catch (err) {
          console.log("gameSearch Error : ", err.message);
        }
      } else {
        setShowSuggestions(false);
      }
    };

    const callFavorite = (gameId) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${token}`);

      const raw = JSON.stringify({
        id: gameId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_URL}/arlivecasinofavioutgame`,
        requestOptions
      )
        .then(async (response) => {
          let paresData = await response.json();
          callAPI(selectedOption, tabType);
          console.log("arlivecasinofavioutgame - ", paresData);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };

    const handleSuggestionClick = (item) => {
      if(isLoggedIn || loggedIn){
        console.log("handleSuggestionClick : ", item);
        navigate(`/live_casinoInPlay/${item._id}`);
        handleClear();
        setShowSuggestions(false); // Hide suggestions when user selects one
      }else{
        openPopup();
      }
    };

    const handleClear = () => {
      console.log("no Record found! clear text");
      setSearchTerm("");
      setResults();
    };

    const handleLikeUnlike = (item) => {
      callFavorite(item._id);
    };

    const handleProvider = (item,index) =>{
      setGameTab('All');
      setSelectTab(item);
      callAPI(item,"All");
      setSelectedProvider(item);
      scrollToTop();
      console.log("handleProvider : ",item);
    }
    const handleType = (type) =>{
      setSelectedType(type);
      callAPI(selectedProvider,type);
      console.log("handleType : ",type);
      setGameTab(type);
      scrollToTop();
    }

    const handleClose = () => {
      setNotificationModal(false);
    }

    const searchFunction = () =>{
      return <div className={`search ${dropdown ? 'open' : ''}`} ref={dropdownRef}>
      <input type="text" placeholder="Search for Casino" className="form-control" value={searchTerm} onChange={handleSearchChange} onFocus={() => setShowSuggestions(true)}/>
      <div className="search-icon" onClick={dropdownHandle}>
          <i className="fas fa-search"></i>
      </div>
      {results && showSuggestions && results?.games?.length > 0 && (
      <ul className="search-result">
          {results.games.map((item, index) => (
          <li
              key={index}
              onClick={() => handleSuggestionClick(item)}
          >
              {item?.game_name}
          </li>
          ))}
      </ul>
      )}
  </div>
    }

    return (
        <div className='content-box casino'>
            <div className="left-content">
                <div className='provider-sec'>
                <div className='fancy-provider-title'>Providers</div>
                <div className="game-provider-tab">
                {providerList && providerList.map((item, index) => (
                    <button className={`link ${item === selectTab ? 'active': ''}`} onClick={()=>handleProvider(item,index)}>
                        <img src="https://wver.sprintstaticdata.com/v108/static/front/img/icons/4.png" alt='' /> <span>{item}</span>
                    </button>
                ))}
                </div>
                </div>
            </div>
            <div className="right-content">
            <div className='fancy-provider-title'>Casino
              {searchFunction()}

                    </div>
                <div className="casino-game-tab">
                    <div className="casino-game-tab-list">
                    {gameName && gameName.map((item, index) => (
                        <span key={index} onClick={()=>handleType(item.id)} className={`link ${item.id === gameTab ? 'active': ''}`}>
                        <img src={`/images${item.url}`} alt='' />
                        {item.name}
                        </span>
                    ))}
                    </div>
                    {searchFunction()}

                </div>
                {liveCasinoApi ?
                    <div className="casino-grid">
                        <ImageGallery allImages={liveCasinoApi} />
                    {/* {liveCasinoApi.map((item, index) => (
                            <Link to={`/live_casinoInPlay/${item._id}`} id={index} className='game-img'>
                                <img src={item.url_thumb} loading="lazy" onError={handleError} placeholder={`https://wver.sprintstaticdata.com/v111/static/front/img/casino/default.jpeg`} alt="" />
                            </Link>
                        ))} */}
                    </div>
                : <div className='please-wait-data'>Please wait data is loading...</div>}

            </div>
        </div>
    )
}
